require('bootstrap/dist/css/bootstrap.css');
require('bootstrap/dist/js/bootstrap.js');
require('../css/app.css');
require('bootstrap-fileinput-npm/css/fileinput.css');
require('selectize/dist/css/selectize.css');
require('selectize/dist/js/selectize.min.js');
require('bootstrap-notify/bootstrap-notify.min.js');
require('bootstrap-datepicker/dist/js/bootstrap-datepicker.min');
require('bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css');
require('eonasdan-bootstrap-datetimepicker/build/js/bootstrap-datetimepicker.min');
require('eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.min.css');
require('jquery.maskedinput/src/jquery.maskedinput.js');
require('font-awesome/css/font-awesome.min.css');

require('bootstrap-fileinput-npm/js/fileinput.min');
require('bootstrap-fileinput-npm/css/fileinput.min.css');

var Marionette = require('backbone.marionette');
var Router = require('./router');
var RootView = require('./controller');

const App = Marionette.Application.extend({
    region: '#app',
    onStart: function(options) {
        var rootView = new RootView(options);
        this.showView(rootView);
        var router = new Router({controller: rootView});
        Backbone.history.start();
    }
});

const myApp = new App();
myApp.start({});


//////////////////
// WEBPACK FOOTER
// ./app/driver.js
// module id = 0
// module chunks = 0